var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrapperTooltipComponent',{attrs:{"content":_vm.formatStatus}},[_c('el-tag',{class:`status ${_vm.status} border-radius text-capitalize font-bold`,attrs:{"type":"default"}},[(_vm.typeStatus == 'short')?_c('span',[_vm._v(" "+_vm._s(_vm.shortCode))]):_c('span',[_vm._v(_vm._s(_vm.formatStatus))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }